export default __webpack_public_path__ + "static/media/9Pack_combinado.195c01cc.png";